import Joi from '@hapi/joi';
// Note: These constants are now loaded dynamically from Redux state
// For static validation, we'll use a broader set of valid values

const VALID_WEATHER_CONDITION_QUALIFIER = [
    'equal',
    'greaterThan',
    'lessThan',
    'greaterThanInclusive',
    'lessThanInclusive',
];

const VALID_WEATHER_CONDITION_TIMEFRAME = [
    'now',
    'next_36h',
    'next_14d',
    'next_3d',
    'next_6d',
    'forecast',
];

const VALID_WEATHER_CONDITION_TYPE = [
    'Rain',
    'Sunny',
    'Temperature',
    'FeelsLike',
    'Snow',
    'humidity',
    'windspeed',
    'heat',
    'haze',
    'fog',
    'iceWarning',
    'freezingRain',
    'pollen',
    'airquality',
    'flu',
    'uv',
    'mosquito',
    'tick',
    'migraine',
    'outdoor',
    'pool',
    'beach',
    'poolandbeach',
    'ski',
];

const schema = Joi.object({
    logicRelationship: Joi.string()
        .valid('and', 'or')
        .optional(),
    conditions: Joi.array()
        .items(
            Joi.object({
                id: Joi.string().required(),
                type: Joi.string()
                    .valid(...VALID_WEATHER_CONDITION_TYPE)
                    .required()
                    .messages({
                        'string.empty': 'Not allowed to be empty',
                    }),
                qualifier: Joi.string()
                    .valid(...VALID_WEATHER_CONDITION_QUALIFIER)
                    .required()
                    .messages({
                        'string.empty': 'Not allowed to be empty',
                    }),
                amount: Joi.number()
                    .when('type', {
                        is: 'Temperature',
                        then: Joi.number()
                            .integer()
                            .required(),
                        otherwise: Joi.number().required(),
                    })
                    .when('type', {
                        is: 'FeelsLike',
                        then: Joi.number()
                            .integer()
                            .required(),
                        otherwise: Joi.number().required(),
                    })
                    .messages({
                        'any.only': 'Not allowed to be empty',
                    }),
                timeframe: Joi.string()
                    .valid(...VALID_WEATHER_CONDITION_TIMEFRAME)
                    .required()
                    .messages({
                        'string.empty': 'Not allowed to be empty',
                    }),
            })
        )
        .optional(),
});

export default schema;
